import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import WellnessBanner from '../../components/guest/guestHome/WellnessBanner';
import WellnessPromoSection from '../../components/guest/guestHome/WellnessPromoSection';
import TrustedBrandsSection from '../../components/guest/guestHome/TrustedBrandsSection';
import Footer from '../../components/Footer';
import { Product } from '../../interface/interface';
import { getAccessories } from '../../service/getAccessories';
import { FEATURED_PRODUCTS_COUNT } from '../../constant/constant';
import { getPromotionalProducts } from '../../service/getPromotionalProducts';
import BannerCarousel from '../../components/guest/guestHome/BannerCarousel';
import FeaturedProducts from '../../components/guest/guestHome/FeaturedProducts';
import { getBannerSlides } from './BannerSlides';

const ShopLanding = () => {
  const { user } = useAuth();
  const isGuest = !user;

  const { data } = useQuery({
    queryKey: ['featured-products', isGuest, user?.access_token],
    queryFn: async (): Promise<Product[] | null> => {
      const result = isGuest
        ? await getPromotionalProducts()
        : await getAccessories(user!.access_token, [], [], []);

      if (typeof result === 'number') {
        throw new TypeError(
          `Failed to load featured products (status ${result})`,
        );
      }

      return result;
    },
    enabled: isGuest || !!user?.access_token,
  });

  const featuredProducts = data?.slice(0, FEATURED_PRODUCTS_COUNT) ?? [];
  const bannerSlides = getBannerSlides(isGuest);

  return (
    <div className="bg-white -mb-16 md:-mb-72">
      <div className="-mt-6 md:-mt-8 2xl:-mt-10">
        <BannerCarousel slides={bannerSlides} autoPlay={true} />
      </div>

      <div className="py-10 md:py-14 bg-grey-100">
        <FeaturedProducts
          title="Featured Products"
          products={featuredProducts}
          viewAllHref={isGuest ? '/guest/shop-non-script' : '/non-script-range'}
          isGuest={isGuest}
        />
      </div>

      <div>
        <WellnessBanner
          eyebrow="Everyday Wellness, Made Simple"
          headingLines={['Small Changes Can', 'Make a Big Difference']}
          description="Everyday support for your health, so you can do more of what you love."
          ctaLabel="Explore Our Range →"
          ctaHref={isGuest ? '/guest/shop-non-script' : '/non-script-range'}
          image={{
            src: '/banners/wellness-beach-banner.png',
            alt: 'A woman in a sun hat sitting on beachside rocks, looking out at the ocean at sunset.',
          }}
        />
      </div>

      <WellnessPromoSection />
      <TrustedBrandsSection />
      <Footer />
    </div>
  );
};

export default ShopLanding;
